import { useQuery } from '@tanstack/react-query'

import { AnnotationTextResponse } from '@tabeeb/contracts/microservices/swagger-ai-service'
import { useApi } from '@tabeeb/modules/shared/utils/API/hooks'
import { AIQueryKeys } from '../queries'

interface UseAIAnnotationTextHookProps {
  aiAnnotationId: number
  enabled?: boolean
}

interface UseAIAnnotationTextHookState {
  loading: boolean
  aiAnnotationText: AnnotationTextResponse | undefined
}

const useAIAnnotationText = ({
  aiAnnotationId,
  enabled = true,
}: UseAIAnnotationTextHookProps): UseAIAnnotationTextHookState => {
  const { aiServiceApi } = useApi()

  const query = useQuery({
    queryKey: [AIQueryKeys.AIAnnotationText, aiAnnotationId],
    queryFn: () => aiServiceApi.annotationAiObjects.getAnnotationTextAsync(aiAnnotationId),
    enabled: enabled && !!aiAnnotationId,
  })

  return { loading: query.isFetching, aiAnnotationText: query.data }
}

export default useAIAnnotationText
